import { Component } from 'react'
import { Select, Icon } from 'antd'

import { CountryWrapper } from './country.style'
import { GENERIC_IMAGES } from '../../constants/images'

const { Option } = Select

const countrySelect = [
  {
    flag: GENERIC_IMAGES.INDONESIA_FLAG,
    name: 'Indonesia',
    locale: 'id'
  }, {
    flag: GENERIC_IMAGES.THAILAND_FLAG,
    name: 'Thailand',
    locale: 'th'
  }, {
    flag: GENERIC_IMAGES.VIETNAM_FLAG,
    name: 'Vietnam',
    locale: 'vi'
  }
]

class Country extends Component {
  state = {
    selectedCountry: localStorage.getItem('country') || 'Indonesia'
  }

  handleCountryChange = (value, option) => {
    const selectedItem = countrySelect.find(item => item.name === value)
    if (selectedItem) {
      localStorage.setItem('locale', selectedItem.locale)
      localStorage.setItem('country', selectedItem.name)
      this.setState({ selectedCountry: value })
      window.location.reload()
    }
  }

  render () {
    return (
      <CountryWrapper>
        <Select
          value={this.state.selectedCountry}
          onChange={this.handleCountryChange}
          suffixIcon={<Icon type='down' />}
          dropdownClassName='country-dropdown'
        >
          {
            countrySelect.map(({ flag, name, locale }) =>
              <Option value={name} className='country-dropdown' key={name}>
                <img width='22' className='flag' src={flag} alt='flag' />{name}
              </Option>
            )
          }
        </Select>
      </CountryWrapper>
    )
  }
}

export default Country
